import * as css from './MemberListLoader.css';

interface MemberListLoaderProps {
    /* First load — fills the sheet; otherwise a thin strip under the list while a page is fetched */
    initial?: boolean;
    'data-cy'?: string;
}

/* The loading indicator shared by the subscription lists.
   Not the library's Loader: that one is a full-screen overlay (fixed inset-0, opaque background)
   for a whole page, and here the list around it has to stay visible while a page is fetched. */
function MemberListLoader({initial, 'data-cy': dataCy}: MemberListLoaderProps) {
    return (
        <css.wrap $initial={initial}>
            <css.spinner data-cy={dataCy} />
        </css.wrap>
    );
}

export default MemberListLoader;
